import React, { Component } from 'react';
import Loader from "../../utils/Loader";
import { ToastContainer } from "react-toastify";
import Footer from "../../common_components/Footer";
import Header from '../../common_components/Header';
import { withRouter } from "../../utils/withRouter";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { connect } from "react-redux";
import { Modal } from "react-bootstrap";
import moment from 'moment';
import { countDownDate_action } from '../../actions/staticAction/static_action';
import { BASE_URL, sessionExpireMessage, toastError, toastSuccess, tokenInavlidMessage } from '../../utils/constants';
import { getWebsiteBlogList_action } from '../../actions/staticAction/static_action'
import purify from 'dompurify'
import JoditEditor from "jodit-react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import {
    getCmsContent_action, insertUpdateCmsContent_action,
    insertUpdateCmsFooter_action, publishCmsContent_action,
    publishCmsFooter_action, insertUpdateCmsContentSection_action,
    updateCmsContentStatus_action, insertUpdateCMSStaticUploads_action,
    deleteCmsStaticFiles_action, insertUpdateCmsBanner_action, publishCmsBanner_action
} from "../../actions/cms_action/cmsAction";
import { get_eventMaster_list_action } from '../../actions/adminAction/event_master_action';

const joditConfig = {
    readonly: false,
    height: 500,
    placeholder: "",
    disableBeautify: true,
    useAceEditor: false,
    uploader: { insertImageAsBase64URI: true },
    showAbout: false,
    showPoweredBy: false,
    buttons: [
        'bold', 'strikethrough', 'underline', 'italic', '|',
        'ul', 'ol', '|',
        'outdent', 'indent', '|', 'image', 'video', 'table', 'link', '|',
        'fontsize', 'brush', 'paragraph', '|',
        'align', 'fullsize', "undo", "redo", "search", '|',
        'source', // <-- This is the code editor toggle
        {
            name: "more",
            iconURL: "https://cdn-icons-png.flaticon.com/512/130/130884.png",
            tooltip: "More Options",
            list: ["superscript", "subscript", "copyformat", "print", "hr", 'copyformat'],
        },
    ],
    toolbarAdaptive: false,
    toolbarSticky: false,
    toolbarButtonSize: "middle",
    buttonsXS: [
        'bold', 'image', '|', 'brush', 'paragraph', '|',
        'align', '|', 'undo', 'redo', '|', 'eraser', 'dots', 'more', 'source' // Added here too
    ],
    buttonsSM: ["bold", "italic", "underline", "link", "more", "source"], // Added here too
    style: {
        toolbar: {
            display: "flex",
            justifyContent: "space-between"
        },
    },
    dropdown: {
        display: "grid",
        gridTemplateColumns: "repeat(2, 1fr)",
        gap: "10px",
        padding: "10px",
    },
    defaultStyle: 'font-family: sans serif; font-size: 14px;',
    placeholder: "",
};

let sectionCounter = 1;

class Homepage extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            slideList: [
                {
                    imgSrc: "assets/img/Upcoming_Events/itmeawardlogo.jpg",
                    title: "ITME-AWARDS",
                    titleDetails: "India ITME Technical Awards aims to encourage high performance & competitive edge in textile engineering field.",
                    isActive: false,
                    date: '20',
                    month: 'MAY',
                    startAndEndDate: '21st Feb - 31st July 2025',
                    location: 'India ITME Society, Nariman Point, Mumbai, India',
                    link: 'https://awards.india-itme.com'
                },
                {
                    imgSrc: "assets/img/Upcoming_Events/gttes2025.jpg",
                    title: "GTTES-2025",
                    titleDetails: "GTTES 2025 will showcase cutting-edge advancements and opportunities, redefining global textile innovation.",
                    isActive: true,
                    date: '26',
                    month: 'JUNE',
                    startAndEndDate: '21st - 23rd Feb 2025',
                    location: 'Bombay Convention & Exhibition Centre, Mumbai, India',
                    link: 'https://corporate.india-itme.com/gttes2025/'
                },
                {
                    imgSrc: "assets/img/Upcoming_Events/2026eventlogo.jpg",
                    title: "ITME-2026",
                    titleDetails: "12th Edition of India ITME is scheduled from 3rd to 8th December 2026 at India Exposition Mart Ltd, Noida.",
                    isActive: false,
                    date: '28',
                    month: 'AUG',
                    startAndEndDate: '04th - 09th DEC 2026',
                    location: 'Greater Noida, Uttar Pradesh',
                    link: 'https://corporate.india-itme.com/itme2026/'
                },
            ],
            whyAttendList: [
                { imgSrc: "https://www.indiadigitalsummit.in/wp-content/themes/IDS/assets/images/why-attend/masterclass.png", title: `Workshops & Masterclasses`, hover: `The Workshops &amp; Masterclasses at IDS25 will offer hands-on, in-depth sessions led by industry experts, focusing on practical applications of emerging technologies. Participate and explore opportunities on emerging technologies like AI, blockchain, quantum computing, and sectoral topics.` },
                { imgSrc: "https://www.indiadigitalsummit.in/wp-content/themes/IDS/assets/images/why-attend/img-2.png", title: `Closed Room Sessions`, hover: `Join Policy &amp; Regulatory Closed Room Sessions to delve into key regulatory issues and contribute to shaping future digital policies.` },
                { imgSrc: "https://www.indiadigitalsummit.in/wp-content/themes/IDS/assets/images/why-attend/startups.png", title: `Startup Pitches`, hover: `Discover and support innovative startups as they present their business ideas to potential investors and partners.` },
                { imgSrc: "https://www.indiadigitalsummit.in/wp-content/themes/IDS/assets/images/why-attend/industry-awards.png", title: 'Industry Awards', hover: `Celebrate achievements and excellence in digital innovation at the India Digital Awards &amp; Digital Responsibility Awards.` },
                { imgSrc: "https://www.indiadigitalsummit.in/wp-content/themes/IDS/assets/images/why-attend/sundowner.png", title: `Sundowners`, hover: `Sundowners at IDS25 provide a networking environment, ideal for creating connections and sparking conversations over casual conversation with industry leaders.` },
                { imgSrc: "https://www.indiadigitalsummit.in/wp-content/themes/IDS/assets/images/why-attend/nightfest.png", title: `Night Fest`, hover: `The Night Fest at IDS25 is a vibrant celebration where attendees can unwind and enjoy an evening of cultural performances, entertainment, and informal networking, blending business with leisure in a lively atmosphere.` },
                { imgSrc: "https://www.indiadigitalsummit.in/wp-content/themes/IDS/assets/images/why-attend/leading-speakers.png", title: `Insights from Leading Speakers`, hover: `Attend keynotes, fireside chats and panel discussions featuring regulators, policymakers, CXOs, founders, and industry experts.` },
                { imgSrc: "https://www.indiadigitalsummit.in/wp-content/themes/IDS/assets/images/why-attend/ceo-dinner.png", title: `CXO Dinner`, hover: `This exclusive networking gathering for industry leaders and policymakers provides a high-level networking opportunity. Engage with decision-makers and influencers during targeted networking gatherings.` },
                { imgSrc: "https://www.indiadigitalsummit.in/wp-content/themes/IDS/assets/images/why-attend/report-launch.png", title: `Research Report`, hover: `Engage with decision-makers and influencers during targeted networking sessions. Stay ahead of industry trends with insights into the latest market developments and technological advancements.` },
                { imgSrc: "https://www.indiadigitalsummit.in/wp-content/themes/IDS/assets/images/why-attend/showcases.png", title: `Product Launches & Showcases`, hover: `IDS25 will unveil cutting-edge solutions and breakthrough innovations across sectors and get first-hand experience of the latest products. Witness more than 20 Product Launches and showcases at the event.` },
                { imgSrc: "https://www.indiadigitalsummit.in/wp-content/themes/IDS/assets/images/why-attend/leadership-roundtable.png", title: `Leadership Roundtables`, hover: `IDS25 will bring together C-level executives, policymakers, and thought leaders for candid discussions on the challenges and opportunities in driving digital transformation.` },
                { imgSrc: "https://www.indiadigitalsummit.in/wp-content/themes/IDS/assets/images/why-attend/ask-me-anything.png", title: `Founders’ opportunity to engage directly with industry experts, innovators, and policymakers.` },

            ],
            teamList: [
                { imgSrc: "assets/img/team/01.jpg", name: "Ronel Smith", designation: 'UX Deginer' },
                { imgSrc: "assets/img/team/01.jpg", name: "Ronel Smith", designation: 'UX Deginer' },
                { imgSrc: "assets/img/team/01.jpg", name: "Ronel Smith", designation: 'UX Deginer' },
                { imgSrc: "assets/img/team/01.jpg", name: "Ronel Smith", designation: 'UX Deginer' },
                { imgSrc: "assets/img/team/01.jpg", name: "Ronel Smith", designation: 'UX Deginer' },
                { imgSrc: "assets/img/team/01.jpg", name: "Ronel Smith", designation: 'UX Deginer' },
            ],
            guestReviewsList: [
                { imgSrc: "assets/img/testimonial/02.jpg", name: "Gordon Novak", designation: 'Our Guest', review: 'There are many variations of passage available the majority have suffered to alteration in some form making it look like readable by injected humour.' },
                { imgSrc: "assets/img/testimonial/02.jpg", name: "Gordon Novak", designation: 'Our Guest', review: 'There are many variations of passage available the majority have suffered to alteration in some form making it look like readable by injected humour.' },
                { imgSrc: "assets/img/testimonial/02.jpg", name: "Gordon Novak", designation: 'Our Guest', review: 'There are many variations of passage available the majority have suffered to alteration in some form making it look like readable by injected humour.' },
                { imgSrc: "assets/img/testimonial/02.jpg", name: "Gordon Novak", designation: 'Our Guest', review: 'There are many variations of passage available the majority have suffered to alteration in some form making it look like readable by injected humour.' },
                { imgSrc: "assets/img/testimonial/02.jpg", name: "Gordon Novak", designation: 'Our Guest', review: 'There are many variations of passage available the majority have suffered to alteration in some form making it look like readable by injected humour.' },
            ],
            ServiceRelated: 'Trade_Missions',
            isCommingSoon: false,
            isOpen: false,
            timeLeft: {},
            intervalId: null,
            popMsg: null,
            popDetails: {},
            blogList: [],
            isSocial: false,
            htmlBlogContent: '', eventMasterList: [],
            //cms
            currentIndex: 0,
            cmsSectionData: [],
            cmsMenuData: [],
            cmsFooterData: [], MenuUrl: '',
            MenuID: '', ContentID: '', SectionName: '',
            SeqNo: '', isFixed: '', isEdit: '', SectionContent: '',
            isactive: '', isPublish: '',
            cmsUploadData: [], downloadUrl: '', cmsBannerData: [], bannerFileErr: '', isStaticUploadOpenBanner: false
        }
        this.slider3Ref = React.createRef()
    }
    componentDidMount() {
        if (!JSON.parse(sessionStorage.getItem("loginDataSS"))) {
            setTimeout(() => {
                this.props.navigate('/');
            }, 200);
            return;
        }
        if (sessionStorage.getItem('RoleIDSS') != 1) {
            setTimeout(() => {
                this.props.navigate('/memberDashboard');
            }, 200);
            return;
        }
        window.scrollTo(0, 0);
        const sortUrl = BASE_URL.split("/api");
        this.setState({ downloadUrl: sortUrl[0] });

        if (this.props.location.pathname == '/cms/manage') {
            this.setState({ MenuUrl: 'home', MenuID: 1, cmsMenuData: [] }, () => {
                this.getCmsContent(1, 'home');
                this.getBlogList()
                this.getEventMasterList()
            });
            return
        }

        const path = this.props.location.pathname; // e.g., '/cms/manage/current-awards&4'
        const cmsPrefix = '/cms/manage/';

        if (path.startsWith(cmsPrefix)) {
            const subPath = path.slice(cmsPrefix.length); // gets 'current-awards&4'
            console.log(path, subPath, 'cmspath')

            const parts = subPath.split('&');

            if (parts.length === 2) {
                const MenuUrlProps = parts[0]; // 'current-awards'
                const MenuIDProps = parts[1];  // '4'

                console.log("Menu URL mount:", MenuUrlProps);
                console.log("Menu ID mount:", MenuIDProps);
                this.setState({ MenuUrl: MenuUrlProps, MenuID: MenuIDProps, cmsMenuData: [] }, () => {
                    this.getCmsContent(MenuIDProps ? MenuIDProps : 1, MenuUrlProps ? MenuUrlProps : 'home');
                    this.getBlogList()
                    this.getEventMasterList()
                });
                // }
            }
        }

    }

    componentDidUpdate(prevProps) {
        const { MenuID } = this.state;
        if (this.props.location.pathname !== prevProps.location.pathname) {
            const urlHash = this.props.location.pathname;
            const cmsPrefix = '/cms/manage/';
            console.log(this.props.location, 'did');

            if (urlHash.includes('RegisteredList')) {
                window.open('#/RegisteredList', '_blank');
            } else if (urlHash.includes('companyProfile')) {
                window.open('#/companyProfile', '_blank');
            } else if (urlHash.includes('buisnessDetails')) {
                window.open('#/buisnessDetails', '_blank');
            } else if (urlHash.includes('payment')) {
                window.open('#/payment', '_blank');
            } else if (urlHash.includes('thankyou')) {
                window.open('#/thankyou', '_blank');
            } else if (urlHash.includes('enquiryForm')) {
                window.open('#/enquiryForm', '_blank');
            } else if (urlHash.includes('eventEnquiryForm')) {
                window.open('#/eventEnquiryForm', '_blank');
            } else {
                if (urlHash.startsWith(cmsPrefix)) {
                    const subPath = urlHash.substring(cmsPrefix.length);
                    const parts = subPath.split('&');
                    if (parts.length === 2) {
                        const MenuUrlProps = parts[0]; // 'current-awards'
                        const MenuIDProps = parts[1];  // '4'

                        if (MenuIDProps === '1') {
                            window.location.reload();
                            return;
                        }
                        this.setState({ MenuUrl: MenuUrlProps, MenuID: MenuIDProps, cmsMenuData: [] }, () => {
                            this.getCmsContent(MenuIDProps, MenuUrlProps);
                        });

                    }
                }
            }

            console.log("URL changed to:", this.props.location.pathname);
        }
    }
    handleBannerChange = (event) => {
        const file = event.target.files[0];
        if (!file) return;

        // Check file size (e.g., 5MB limit)
        if (file.size > 5 * 1024 * 1024) {
            this.setState({ bannerFileErr: 'File size should be less than 5MB' });
            return;
        }

        const reader = new FileReader();
        const fileExt = file.name.split('.').pop();

        reader.onload = (e) => {
            // Prepare the banner data object
            const bannerData = {
                BannerID: this.state.cmsBannerData?.BannerID || 0,
                MenuID: this.state.MenuID,
                FileName: file.name,
                formFile: e.target.result.split(',')[1], // Base64 content
                formFileType: fileExt,
                FilePreview: e.target.result, // This is used for the <img src=...>
                isActive: 1,
                isPublish: 0
            };

            this.setState({
                cmsBannerData: bannerData,
                bannerFileErr: ''
            });
        };

        reader.readAsDataURL(file);
    };

    // Add this to clear the file if needed
    clearFileInput = () => {
        if (this.fileInputRef) this.fileInputRef.value = "";
        this.setState({
            cmsBannerData: {
                ...this.state.cmsBannerData,
                BannerFilepath: "",
                FilePreview: ""
            }
        });
    };
    //dynamic cmsSectionData
    async getCmsContent(MenuID, MenuURL) {
        const path = this.props.location.pathname;
        const cmsPrefix = '/cms/manage/';
        let MenuUrlProps
        let MenuIDProps
        if (path.startsWith(cmsPrefix)) {
            const subPath = path.slice(cmsPrefix.length);
            console.log(path, subPath, 'cmspath')

            const parts = subPath.split('&');

            if (parts.length === 2) {
                MenuUrlProps = parts[0];
                MenuIDProps = parts[1];
            }
        }
        try {
            this.setState({ isLoading: true });

            const data = await this.props.getCmsContent_action(MenuID ? MenuID : MenuIDProps ? MenuIDProps : 1, MenuURL ? MenuURL : MenuUrlProps ? MenuUrlProps : 'home');

            if (data.error !== 1) {
                this.setState({
                    isLoading: false,
                    cmsSectionData: data?.data[0] !== "" ? data?.data[0] : [],
                    cmsMenuData: data?.data[1] !== "" ? data?.data[1] : [],
                    cmsFooterData: data?.data[2][0] !== "" ? data?.data[2][0] : [],
                    cmsUploadData: data?.data[3] !== "" ? data?.data[3] : [],
                    cmsSubheaderData: data?.data[4] !== "" ? data?.data[4] : [],
                    cmsBannerData: data?.data[5][0] !== "" ? data?.data[5][0] : [],
                });
            } else {
                this.setState({ isLoading: false });
                toastError(data.msg);
                if (data.msg == 'Page not found.') {
                    if (this.props.location.pathname.includes('cms/manage')) {
                        window.location.reload()
                        this.props.navigate('/cms/manage')
                    } else {
                        window.location.reload()
                        this.props.navigate('/')
                    }
                }
            }
        } catch (err) {
            console.error(err);
            this.setState({ isLoading: false });
        }
    }
    async InsertUpdateCmsContentSection(ContentID, MenuID, SeqNo, isFixed, isEdit, SectionContent, isPublish, isactive) {
        try {
            this.setState({ isLoading: true });
            if (SectionContent == '' || SectionContent == '<p><br/></p>') {
                toastError('Kindly Enter Content')
            } else {
                const data = await this.props.insertUpdateCmsContentSection_action(ContentID, MenuID, SeqNo, isFixed, isEdit, SectionContent, isPublish, isactive);
                if (data.error !== 1) {
                    this.setState({ isLoading: false });
                    if (data.data !== "") {
                        toastSuccess('Content Added Successfully')
                        this.getCmsContent();
                    }
                } else {
                    this.setState({ isLoading: false });
                    toastError(data.msg);
                }
            }

        } catch (err) {
            console.error(err);
            this.setState({ isLoading: false });
        }
    }
    async InsertUpdateCmsContent() {
        try {
            const { cmsSectionData } = this.state;
            this.setState({ isLoading: true });
            const hasInvalidContent = cmsSectionData.some(section => {
                const content = section.SectionContent?.trim();
                return !content || content === '<p><br/></p>';
            });

            if (hasInvalidContent) {
                toastError('Kindly Enter Content in all sections');
                this.setState({ isLoading: false });
                return;
            } else {
                const data = await this.props.insertUpdateCmsContent_action(cmsSectionData);

                if (data.error !== 1) {
                    this.setState({ isLoading: false });
                    if (data.data !== "") {
                        toastSuccess('Contents Added Successfully')
                        this.getCmsContent();
                    }
                } else {
                    this.setState({ isLoading: false });
                    toastError(data.msg);
                }
            }
        } catch (err) {
            console.error(err);
            this.setState({ isLoading: false });
        }
    }
    async insertUpdateFooter() {
        try {
            const { cmsFooterData } = this.state;
            this.setState({ isLoading: true });
            if (cmsFooterData.FooterContent == '' || cmsFooterData.FooterContent == '<p><br/></p>') {
                toastError('Kindly Enter Footer Section')
            } else {
                const data = await this.props.insertUpdateCmsFooter_action(cmsFooterData);

                if (data.error !== 1) {
                    this.setState({ isLoading: false });
                    if (data.data !== "") {
                        toastSuccess('Footer Saved Successfully')
                        this.getCmsContent()
                    }
                } else {
                    this.setState({ isLoading: false });
                    toastError(data.msg);
                }
            }
        } catch (err) {
            console.error(err);
            this.setState({ isLoading: false });
        }
    }
    async updateCmsContentStatus(ContentID, isactive) {
        try {
            const { MenuID } = this.state;
            this.setState({ isLoading: true });

            const data = await this.props.updateCmsContentStatus_action(MenuID, ContentID, isactive);

            if (data.error !== 1) {
                this.setState({ isLoading: false });
                if (data.data !== "") {
                    toastSuccess(`Content ${isactive == 1 ? 'Activated' : 'In-Activated'} Successfully`)
                    this.getCmsContent();
                }
            } else {
                this.setState({ isLoading: false });
                toastError(data.msg);
            }
        } catch (err) {
            console.error(err);
            this.setState({ isLoading: false });
        }
    }
    async deleteCmsStaticFiles(FileID) {
        try {
            const { MenuID } = this.state;
            this.setState({ isLoading: true });

            const data = await this.props.deleteCmsStaticFiles_action(MenuID, FileID);

            if (data.error !== 1) {
                this.setState({ isLoading: false });
                if (data.data !== "") {
                    toastSuccess(`File Deleted Successfully`)
                    this.getCmsContent();
                }
            } else {
                this.setState({ isLoading: false });
                toastError(data.msg);
            }
        } catch (err) {
            console.error(err);
            this.setState({ isLoading: false });
        }
    }
    async PublishCmsContent(ContentID, isPublish) {
        try {
            const { MenuID } = this.state;
            this.setState({ isLoading: true });

            const data = await this.props.publishCmsContent_action(MenuID, ContentID, isPublish);

            if (data.error !== 1) {
                this.setState({ isLoading: false });
                if (data.data !== "") {
                    toastSuccess(`Content ${isPublish == 1 ? 'Published' : 'Unpublished'} Successfully`)
                    this.getCmsContent();
                }
            } else {
                this.setState({ isLoading: false });
                toastError(data.msg);
            }
        } catch (err) {
            console.error(err);
            this.setState({ isLoading: false });
        }
    }

    async PublishCmsFooter(isPublish) {
        const { cmsFooterData } = this.state
        try {
            this.setState({ isLoading: true });

            const data = await this.props.publishCmsFooter_action(cmsFooterData.FooterID, isPublish);

            if (data.error !== 1) {
                this.setState({ isLoading: false });
                if (data.data !== "") {
                    toastSuccess(`Footer ${isPublish == 1 ? 'Published' : 'Unpublished'} Successfully`)
                    this.getCmsContent();
                }
            } else {
                this.setState({ isLoading: false });
                toastError(data.msg);
            }
        } catch (err) {
            console.error(err);
            this.setState({ isLoading: false });
        }
    }
    async PublishCmsBanner(isPublish) {
        const { cmsBannerData } = this.state
        try {
            this.setState({ isLoading: true });

            const data = await this.props.publishCmsBanner_action(cmsBannerData.BannerID, isPublish);

            if (data.error !== 1) {
                this.setState({ isLoading: false });
                if (data.data !== "") {
                    toastSuccess(`Banner ${isPublish == 1 ? 'Published' : 'Unpublished'} Successfully`)
                    this.getCmsContent();
                }
            } else {
                this.setState({ isLoading: false });
                toastError(data.msg);
            }
        } catch (err) {
            console.error(err);
            this.setState({ isLoading: false });
        }
    }
    UploadBannerFile = async () => {
        const { cmsBannerData, MenuID } = this.state;

        // Check if data exists
        if (!cmsBannerData || Object.keys(cmsBannerData).length === 0) {
            toastError('Kindly Upload File');
            this.setState({ bannerFileErr: 'Kindly Upload File' });
            return;
        }

        try {
            this.setState({ isLoading: true });

            // Get UserID from session storage
            const loginData = JSON.parse(sessionStorage.getItem("loginDataSS"));
            const UserID = loginData ? loginData.UserID : null;

            const data = await this.props.insertUpdateCmsBanner_action(cmsBannerData.BannerID,cmsBannerData.BannerFilepath,cmsBannerData.formFileType,cmsBannerData.FileName,cmsBannerData.formFile,cmsBannerData.isPublish,cmsBannerData.isActive);

            if (data.error !== 1) {
                this.setState({
                    isLoading: false,
                    isStaticUploadOpenBanner: false,
                    bannerFileErr: ''
                });
                if (data.data !== "") {
                    toastSuccess('Banner Uploaded Successfully');
                    this.getCmsContent(MenuID); // Refresh data
                }
            } else {
                this.setState({ isLoading: false });
                toastError(data.msg);
            }

        } catch (err) {
            console.error("Upload Error:", err);
            this.setState({ isLoading: false });
            toastError("Something went wrong during upload.");
        }
    }
    UploadStaticFiles = async () => {
        const { cmsUploadData } = this.state;

        try {
            this.setState({ isLoading: true });
            if (cmsUploadData.length == 0) {
                toastError('Kindly Upload Files')
            } else {
                const data = await this.props.insertUpdateCMSStaticUploads_action(cmsUploadData);
                if (data.error !== 1) {
                    this.setState({ isLoading: false, isStaticUploadOpen: false });
                    if (data.data !== "") {
                        toastSuccess('Files Uploaded Successfully')
                        this.getCmsContent();
                    }
                } else {
                    this.setState({ isLoading: false });
                    toastError(data.msg);
                }
            }

        } catch (err) {
            console.error(err);
            this.setState({ isLoading: false });
        }
    }
    toggleUploadFileOpen = () => {
        this.setState({ isStaticUploadOpen: true })
    }
    toggleUploadFileOpenBanner = () => {
        this.setState({ isStaticUploadOpenBanner: true })
    }
    handleAddSection = () => {
        const { ContentID, MenuID } = this.state;
        const sectionName = `section-${sectionCounter++}`;
        const newSection = {
            SectionName: sectionName,
            ContentID: ContentID ? ContentID : 0,
            MenuID: MenuID ? MenuID : 1,
            SeqNo: this.state.cmsSectionData.length + 1,
            isFixed: false,
            isEdit: true,
            SectionContent: '',
            isactive: 1,
            isPublish: 0
        };

        this.setState(
            prevState => ({
                cmsSectionData: [...prevState.cmsSectionData, newSection]
            }),
            () => {
                // Scroll to the new section after it's rendered
                setTimeout(() => {
                    const el = document.getElementById(sectionName);
                    if (el) {
                        el.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    }
                }, 100); // Give React time to render
            }
        );
    };

    handleEditorChange = (content, index) => {
        const cmsSectionData = [...this.state.cmsSectionData];
        cmsSectionData[index].SectionContent = content;
        this.setState({ cmsSectionData });
    };
    handleEditorChangeFooter = (content) => {
        const cmsFooterData = { ...this.state.cmsFooterData }; // shallow copy of the object
        cmsFooterData.FooterContent = content;
        this.setState({ cmsFooterData });
    };

    onDragEnd = (result) => {
        const { destination, source } = result;
        if (!destination) return;

        const sourceSection = this.state.cmsSectionData[source.index];
        const destSection = this.state.cmsSectionData[destination.index];

        // Don't allow drag if either isFixed
        if (sourceSection.isFixed || destSection.isFixed) return;

        const items = Array.from(this.state.cmsSectionData);
        const [reorderedItem] = items.splice(source.index, 1);
        items.splice(destination.index, 0, reorderedItem);

        // Update sequence numbers
        items.forEach((item, index) => {
            item.SeqNo = index + 1;
        });

        this.setState({ cmsSectionData: items });
    };
    handleRemoveSection = (indexToRemove, ContentID) => {
        let updatedcmsSectionData;

        if (ContentID !== 0) {
            updatedcmsSectionData = this.state.cmsSectionData.map((section, index) => {
                if (index === indexToRemove) {
                    return {
                        ...section,
                        isactive: 0
                    };
                }
                return section;
            });
        } else {
            updatedcmsSectionData = this.state.cmsSectionData.filter((_, index) => index !== indexToRemove);
        }

        const reSequenced = updatedcmsSectionData.map((section, idx) => ({
            ...section,
            SeqNo: idx + 1
        }));

        this.setState({ cmsSectionData: reSequenced });
    };
    toggleSectionStatus = (index, ContentID, isactive) => {
        const updatedcmsSectionData = this.state.cmsSectionData.map((section, idx) => {
            if (idx === index) {
                return {
                    ...section,
                    isactive: section.isactive ? 0 : 1,
                };
            }
            return section;
        });

        this.setState({ cmsSectionData: updatedcmsSectionData }, () => {
            this.updateCmsContentStatus(ContentID, !isactive)
        });
    };
    handleFileChange = (event) => {
        const files = Array.from(event.target.files);

        if (files.length > 10) {
            alert("You can upload a maximum of 10 files.");
            return;
        }

        const oversized = files.find(file => file.size > 20 * 1024 * 1024); // 20MB
        if (oversized) {
            alert(`File "${oversized.name}" exceeds the 20MB limit.`);
            return;
        }

        const newUploadData = files.map(file => {
            const reader = new FileReader();
            const fileExt = file.name.split('.').pop();

            return new Promise((resolve) => {
                reader.onload = (e) => {
                    resolve({
                        FileID: 0,
                        MenuID: this.state.MenuID, // adjust as per your logic
                        FilePath: "",
                        FileName: file.name,
                        formFile: e.target.result.split(',')[1], // base64 part only
                        formFileType: fileExt,
                        FilePath: '',
                        isPublish: 1,
                        isActive: 1
                    });
                };
                reader.readAsDataURL(file);
            });
        });

        Promise.all(newUploadData).then(uploadData => {
            this.setState(prevState => ({
                cmsUploadData: [...(prevState.cmsUploadData || []), ...uploadData]
            }));
        });
    };
    removeFile = (index, FileID) => {
        this.setState(prevState => {
            const updatedFiles = [...prevState.cmsUploadData];
            const file = updatedFiles[index];
            if (file.FileID && file.FileID !== 0) {
                updatedFiles[index].isActive = 0;
                this.deleteCmsStaticFiles(FileID);
            } else {
                updatedFiles.splice(index, 1); // Remove completely
            }
            return { cmsUploadData: updatedFiles };
        });
    };
    getEventMasterList() {
        const { Title } = this.state
        this.setState({ isLoading: true })
        this.props
            .get_eventMaster_list_action(Title)
            .then((data) => {
                if (data.error != 1) {
                    this.setState({ eventMasterList: data.data });
                    setTimeout(() => {
                        this.setState({ isLoading: false });
                    }, 500);
                } else {
                    if (data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage) {
                        //after session expire.....................
                        sessionStorage.clear();
                        this.props.navigate("/");
                        setTimeout(() => {
                            toastError(data.msg);
                        }, 2000);
                    } else {
                        toastError(data.data);
                    }
                    this.setState({ isLoading: false })
                    toastError(data.data.ErrorMsg);
                }
            }).catch((e) => {
                console.log(e);
                this.setState({ isLoading: false });
            });
    }
    getBlogList() {
        const { } = this.state
        this.setState({ isLoading: true })
        this.props
            .getWebsiteBlogList_action()
            .then((data) => {
                if (data.error != 1) {
                    this.setState({
                        blogList: data?.data,
                    })
                    setTimeout(() => {
                        this.setState({ isLoading: false })
                    }, 500);
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((e) => {
                console.log(e);
            });

    }

    getCountDownDate(navigateTo) {
        const { } = this.state
        this.setState({ isLoading: true })
        this.props
            .countDownDate_action()
            .then((data) => {
                console.log(data)
                if (data.error != 1) {
                    if (data.data != []) {
                        const LaunchDate = data.data[0]['countDownDate']
                        const targetDate = moment.utc(LaunchDate);
                        const currentDate = moment();
                        const split = currentDate.format().split('+')
                        const updateCurrentDate = split[0] + 'Z'
                        const totalSeconds = targetDate.diff(updateCurrentDate, 'seconds');

                        const array = LaunchDate != null && this.formatDate(LaunchDate);
                        if (totalSeconds >= 0) {
                            const timer = setInterval(() => {
                                this.setState({ timeLeft: this.calculateTimeLeft(LaunchDate) }, () => {
                                    sessionStorage.setItem("navigateTo", navigateTo);
                                    this.setState({ isOpen: true, isLoading: false, isCommingSoon: false, popMsg: 'registration', popDetails: array });
                                });
                            }, 1000);
                            this.setState({ intervalId: timer });
                        } else {
                            this.setState({ isCommingSoon: true, isLoading: false });
                            this.props.navigate(navigateTo);
                            if (navigateTo === '/companyProfile') {
                                sessionStorage.setItem('currentPage', 'companyProfile');
                            }
                            sessionStorage.removeItem('navigateTo');
                            this.setState({ isOpen: false });
                        }

                    } else {
                        this.setState({ isLoading: false });
                    }

                } else {
                    this.setState({ isLoading: false })
                    toastError(data.data.ErrorMsg);
                }
            })
    }

    getEnquiryDate(navigateTo) {
        const { } = this.state
        this.setState({ isLoading: true })
        this.props
            .countDownDate_action()
            .then((data) => {
                console.log(data)
                if (data.error != 1) {
                    if (data.data != []) {
                        const LaunchDate = data.data[0]['enquiryDate']
                        const targetDate = moment.utc(LaunchDate);
                        const currentDate = moment();
                        const split = currentDate.format().split('+')
                        const updateCurrentDate = split[0] + 'Z'
                        const totalSeconds = targetDate.diff(updateCurrentDate, 'seconds');

                        const array = LaunchDate != null && this.formatDate(LaunchDate);
                        if (totalSeconds >= 0) {
                            const timer = setInterval(() => {
                                this.setState({ timeLeft: this.calculateTimeLeft(LaunchDate) }, () => {
                                    sessionStorage.setItem("navigateTo", navigateTo);
                                    this.setState({ isOpen: true, isLoading: false, isCommingSoon: false, popMsg: 'enquiry', popDetails: array });
                                });
                            }, 1000);
                            this.setState({ intervalId: timer });
                        } else {
                            this.setState({ isCommingSoon: true, isLoading: false });
                            this.props.navigate(navigateTo);
                            sessionStorage.removeItem('navigateTo');
                            this.setState({ isOpen: false });
                        }

                    } else {
                        this.setState({ isLoading: false });
                    }

                } else {
                    this.setState({ isLoading: false })
                    toastError(data.data.ErrorMsg);
                }
            })
    }

    formatDate(dateString) {
        const dateObj = new Date(dateString);
        const date = dateObj.getUTCDate();
        const month = dateObj.toLocaleString('en-US', { month: 'long', timeZone: 'UTC' });
        const year = dateObj.getUTCFullYear();
        const time = dateObj.toISOString().split('T')[1].slice(0, 5);

        function getOrdinalSuffix(day) {
            if (day > 3 && day < 21) return "th"; // Covers 4-20
            switch (day % 10) {
                case 1: return "st";
                case 2: return "nd";
                case 3: return "rd";
                default: return "th";
            }
        }

        return {
            date,
            month,
            year,
            time,
            pronounce: getOrdinalSuffix(date)
        };
    }

    calculateTimeLeft = (LaunchDate) => {

        const targetDate = moment.utc(LaunchDate);  // Target in UTC
        // console.log("Target Date in UTC: ", targetDate.format()); 

        // Current date in UTC
        const currentDate = moment();  // Current date in UTC
        // console.log("Current Date in UTC: ", currentDate.format().split('+'));
        const split = currentDate.format().split('+')
        const updateCurrentDate = split[0] + 'Z'
        // console.log("Current Date in UTC: ", updateCurrentDate);

        // Calculate the difference between the current time and target time in total seconds
        const totalSeconds = targetDate.diff(updateCurrentDate, 'seconds');

        // Calculate the total minutes, hours, and days
        const days = Math.floor(totalSeconds / (60 * 60 * 24)); // Convert seconds to days
        const hours = Math.floor((totalSeconds % (60 * 60 * 24)) / (60 * 60)); // Convert remainder to hours
        const minutes = Math.floor((totalSeconds % (60 * 60)) / 60); // Convert remainder to minutes
        const seconds = totalSeconds % 60; // Remainder is the seconds

        // If the countdown reaches 0, close the modal and trigger 'handleRegisterNow'
        console.log("this.state.isOpen -->", this.state.isOpen)
        if (days == 0 && hours == 0 && minutes == 0 && seconds == 0) {
            const { intervalId } = this.state;
            if (intervalId) {
                clearInterval(intervalId); // Stop the timer
                this.setState({ intervalId: null }); // Reset the interval ID
            }
            const navigateTo = sessionStorage.getItem('navigateTo');
            if (navigateTo) {
                this.props.navigate(navigateTo);

                if (navigateTo === '/companyProfile') {
                    sessionStorage.setItem('currentPage', 'companyProfile');
                }

                sessionStorage.removeItem('navigateTo');
                this.setState({ isOpen: false });
            }

        }

        return {
            days: days < 10 ? `0${days}` : days,
            hours: hours < 10 ? `0${hours}` : hours,
            minutes: minutes < 10 ? `0${minutes}` : minutes,
            seconds: seconds < 10 ? `0${seconds}` : seconds,
        };
    };

    handleAfterChange = (current, settings) => {
        const { slideList } = this.state;
        const middleIndex = Math.floor(settings.slidesToShow / 2); // Get the middle index

        // Reset all slides' isActive to false
        slideList.forEach((slide) => {
            slide.isActive = false;
        });

        // Calculate the new active slide index
        const newActiveIndex = (current + middleIndex) % slideList.length;

        // Set the middle slide as active
        slideList[newActiveIndex].isActive = true;

        // Update the state
        this.setState({ slideList });
    };


    handleRegisterNow() {
        this.props.navigate('/companyProfile')
        sessionStorage.setItem("currentPage", 'companyProfile')
    }


    sanitizeAndResizeImages = (htmlContent) => {
        const div = document.createElement("div");
        div.innerHTML = purify.sanitize(htmlContent);

        // Resize all images
        div.querySelectorAll("img").forEach((img) => {
            img.style.width = "450px";  // Make image responsive within the fixed box
            img.style.height = "315px"; // Maintain aspect ratio
            img.style.objectFit = "cover"; // Ensure full coverage
        });
        div.querySelectorAll("span").forEach((span) => {
            span.style.display = "inline-block";
            span.style.lineHeight = "23px";
        });

        return div.innerHTML;
    };

    shareOnWhatsApp = () => {
        const htmlString = `<p>Sagar Jogmerkar</p><img src="https://tradedesk_uat.india-itme.com/document/header-footer/email-header.png" />`;

        // Extract text & image from HTML
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlString, "text/html");

        const text = doc.querySelector("p")?.textContent || "";
        const imgSrc = doc.querySelector("img")?.getAttribute("src") || "";

        if (text) {
            let message = `${text}`;
            if (imgSrc) {
                message += `\n\n${imgSrc}`; // Add the image URL to the message
            }
            const whatsappUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(message)}`;
            window.open(whatsappUrl, "_blank");
        }
    };

    shareOnTwitter = () => {
        const htmlString = `<p>Sagar Jogmerkar</p><img src="https://india-itme.com/document/Exhibition/mailHeaderImage/3/mailHeaderImage3.jpeg" />`;

        // Extract text & image from HTML
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlString, "text/html");

        const text = doc.querySelector("p")?.textContent || "";
        const imgSrc = doc.querySelector("img")?.getAttribute("src") || "";

        if (text) {
            let message = `${text}`;
            if (imgSrc) {
                message += `\n\nImage: ${imgSrc}`; // Include the image URL
            }

            // Twitter Web Intent URL
            const twitterUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(message)}`;

            // Open Twitter Share Dialog
            window.open(twitterUrl, "_blank");
        }
    };


    shareOnFacebook = () => {
        const htmlString = `<p>Sagar Jogmerkar</p><img src="https://india-itme.com/document/Exhibition/mailHeaderImage/3/mailHeaderImage3.jpeg" />`;

        // Extract text & image from HTML
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlString, "text/html");

        const text = doc.querySelector("p")?.textContent || "";
        const imgSrc = doc.querySelector("img")?.getAttribute("src") || "";

        let facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(imgSrc)}`;
        if (text) {
            facebookUrl += `&quote=${encodeURIComponent(text)}`;
        }

        window.open(facebookUrl, "_blank");
    };

    navigateBlogDetails(BlogID) {
        this.props.navigate(`/blogDetails/${BlogID}`, { state: { BlogID: BlogID } })
    }

    truncateSpecificTags = (htmlContent, maxLength = 275) => {
        if (!htmlContent) return "";

        // Create a temporary DOM parser
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlContent, "text/html");

        // Find all <p> and <span> elements inside the HTML
        const targetElements = doc.querySelectorAll("p, span");

        targetElements.forEach((element) => {
            let textContent = element.textContent.trim();

            if (textContent.length > maxLength) {
                let truncatedText = textContent.substring(0, maxLength) + "...";

                // Preserve child elements inside <p> or <span>
                element.innerHTML = truncatedText;
            }
        });

        return doc.body.innerHTML; // Return modified HTML content
    }

    render() {
        const { isLoading, isOpen, timeLeft, popMsg, popDetails, blogList, cmsSectionData, cmsMenuData,
            cmsFooterData, MenuID, isStaticUploadOpenBanner, isStaticUploadOpen, MenuUrl, cmsBannerData, bannerFileErr,
            eventMasterList, downloadUrl, } = this.state
        const dynamicSettings = {
            dots: false,
            // infinite: eventMasterList.length > 1, // Only infinite if more than 1 slide
            infinite: 1,
            speed: 500,
            // slidesToShow: eventMasterList.length < 3 ? eventMasterList.length : 3,
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
            autoplay: false,
            autoplaySpeed: 3000,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: false,
                    },
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: false,
                    },
                },
            ],
            beforeChange: (current, next) => this.handleAfterChange(next, dynamicSettings),
        };
        return (
            <>
                {isLoading ? (
                    <Loader />
                ) : (
                    null
                )}
                {!isLoading && <Header headerNavs={cmsMenuData} />}

                <ToastContainer />
                {/* <MouseCursor /> */}
                <div class="mouse-cursor cursor-outer"></div>
                <div class="mouse-cursor cursor-inner"></div>
                <section class="hero-section section-padding pb-0 fix">
                    <div className="mx-2" style={{ margin: 'auto', }}>
                        <h2 className="mb-2 text-center">CMS Section Editors {" "}
                        </h2>
                        <div className="d-flex justify-content-center mb-3">
                            <button className="btn btn-sm px-3 p-1 rounded-1 edit-submit-btn mb-1 mt-1" onClick={this.handleAddSection}>
                                Add Section
                            </button>
                            <button className="btn btn-sm px-3 p-1 rounded-1 ml-1 add-sec-btn mx-2 mb-1 mt-1" onClick={this.toggleUploadFileOpen}>
                                Upload Files
                            </button>

                            <button className="btn btn-sm px-3 p-1 rounded-1 edit-submit-btn mb-1 mt-1" onClick={this.toggleUploadFileOpenBanner}>Upload Banner</button>
                        </div>


                        <DragDropContext onDragEnd={this.onDragEnd}>
                            <Droppable droppableId="cmsSectionData-droppable">
                                {(provided) => (
                                    <div {...provided.droppableProps} ref={provided.innerRef}>
                                        {cmsSectionData?.length > 0 ? cmsSectionData?.map((section, index) => (
                                            <React.Fragment key={section.ContentID}>
                                                <Draggable
                                                    key={section.ContentID}
                                                    draggableId={String(section.ContentID)}
                                                    index={index}
                                                    isDragDisabled={section.isFixed}
                                                >
                                                    {(provided) => (
                                                        <div
                                                            id={section.SectionName}
                                                            className="focus-sec first-sec"
                                                            ref={provided.innerRef}
                                                            {...provided.draggableProps}
                                                            style={{
                                                                border: '1px solid #ccc',
                                                                padding: '10px',
                                                                borderRadius: '10px',
                                                                marginBottom: '15px',
                                                                backgroundColor: '#f9f9f9',
                                                                ...provided.draggableProps.style,
                                                            }}
                                                        >
                                                            <div
                                                                {...provided.dragHandleProps}
                                                                style={{
                                                                    marginBottom: '5px',
                                                                    display: 'flex',
                                                                    justifyContent: 'space-between',
                                                                    alignItems: 'center',
                                                                    cursor: 'grab',
                                                                }}
                                                            >
                                                                <strong style={{ color: '#007bff' }}>Section #{section.SeqNo}</strong>
                                                                <div>
                                                                    {section.isFixed && (
                                                                        <span style={{ color: 'red', marginRight: '10px' }}>
                                                                            (Fixed)
                                                                        </span>
                                                                    )}
                                                                    <button
                                                                        className="btn btn-sm px-3 p-1 rounded-1 edit-submit-btn mx-2 "
                                                                        onClick={() =>
                                                                            this.InsertUpdateCmsContentSection(
                                                                                section.ContentID,
                                                                                section.MenuID,
                                                                                section.SeqNo,
                                                                                section.isFixed,
                                                                                section.isEdit,
                                                                                section.SectionContent,
                                                                                section.isPublish,
                                                                                section.isactive
                                                                            )
                                                                        }
                                                                    >
                                                                        Submit
                                                                    </button>
                                                                    <button
                                                                        className="btn btn-sm px-3 p-1 rounded-1 ml-1 add-sec-btn "
                                                                        onClick={this.handleAddSection}
                                                                    >
                                                                        Add Section
                                                                    </button>
                                                                    {section.isactive && (
                                                                        <>
                                                                            {section.isPublish ? (
                                                                                <button
                                                                                    className="btn btn-sm p-1 px-3 mx-1 rounded-1 add-unp-btn mx-2 "
                                                                                    onClick={() =>
                                                                                        this.PublishCmsContent(section.ContentID, 0)
                                                                                    }
                                                                                >
                                                                                    Unpublish
                                                                                </button>
                                                                            ) : (
                                                                                <button
                                                                                    className="btn btn-sm p-1 px-3 mx-1 rounded-1 btn-pub-btn "
                                                                                    onClick={() =>
                                                                                        this.PublishCmsContent(section.ContentID, 1)
                                                                                    }
                                                                                >
                                                                                    Publish
                                                                                </button>
                                                                            )}
                                                                        </>
                                                                    )}
                                                                    {!section.isFixed && (
                                                                        <>
                                                                            {section.ContentID === 0 ? (
                                                                                <button
                                                                                    className="btn btn-sm px-3 p-1 rounded-1"
                                                                                    onClick={() =>
                                                                                        this.handleRemoveSection(index, section.ContentID)
                                                                                    }
                                                                                >
                                                                                    Remove
                                                                                </button>
                                                                            ) : (
                                                                                <button
                                                                                    className={`btn btn-sm px-3 p-1 rounded-1 btn-pub-btn-1 ml-1 ${section.isactive && 'btn-in-act-btn ml-1'}`}
                                                                                    onClick={() =>
                                                                                        this.toggleSectionStatus(index, section.ContentID, section.isactive)
                                                                                    }
                                                                                >
                                                                                    {section.isactive ? 'In-Activate' : 'Activate'}
                                                                                </button>
                                                                            )}
                                                                        </>
                                                                    )}
                                                                </div>
                                                            </div>

                                                            {section.isEdit ? (
                                                                <JoditEditor
                                                                    key={section.ContentID || 0}
                                                                    value={section.SectionContent}
                                                                    config={joditConfig}
                                                                    onChange={(content) => this.handleEditorChange(content, index)}
                                                                />
                                                            ) : (
                                                                <div dangerouslySetInnerHTML={{ __html: section.SectionContent }} />
                                                            )}
                                                        </div>
                                                    )}
                                                </Draggable>

                                                {/* Insert Upcoming Events after the first section (index === 0) */}
                                                {index === 0 && MenuID == 1 && eventMasterList.length > 0 && (
                                                    <section className="wcu-section section-padding fix pb-5">
                                                        <div className="wcu-wrapper style2">
                                                            <div className="container">
                                                                <div className="row align-items-center mb-45">
                                                                    <div className="col-xl-12 text-center">
                                                                        <div className="section-title mb-3 mb-xl-0">
                                                                            <div className="subtitle" style={{ display: "block" }}>
                                                                                <img src="assets/img/icon/arrowLeft_1.svg" alt="icon" /> <span> Events </span>
                                                                                <img src="assets/img/icon/arrowRight_1.svg" alt="icon" />
                                                                            </div>
                                                                            <h2 className="title">Upcoming Events</h2>
                                                                        </div>
                                                                        <p className="desc mb-3 mb-xl-0 text-center">
                                                                            {/* You can choose display Featured, Upcoming, Past, Creation Date here */}
                                                                        </p>
                                                                    </div>
                                                                </div>

                                                                <div className="row gy-5">
                                                                    <div className="col-lg-12">
                                                                        <div className="slider-container">
                                                                            <Slider {...dynamicSettings} className="slider1">
                                                                                {eventMasterList.map((item) => (
                                                                                    <div className="slide mr-2 d-flex justify-content-center" key={item.EventID}>
                                                                                        <a href={item.URL} target="_blank" rel="noopener noreferrer">
                                                                                            <div className="event-image">
                                                                                                <img
                                                                                                    src={`${downloadUrl + item.FilePath}`}
                                                                                                    alt="Event"
                                                                                                    style={{ height: '320px', margin: 'auto' }}
                                                                                                />
                                                                                            </div>
                                                                                        </a>
                                                                                        <div className={item.isActive ? 'event-content-active' : 'event-content'}>
                                                                                            <a href={item.URL} target="_blank" rel="noopener noreferrer">
                                                                                                <div className="event-title mb-10 text-center">
                                                                                                    <h3 className="title">{item.Title}</h3>
                                                                                                    <p className="title_details text-left">{item.Description}</p>
                                                                                                    {item.PriceInr && (
                                                                                                        <span className="ticket-price">Tickets from {item.PriceInr}</span>
                                                                                                    )}
                                                                                                </div>
                                                                                            </a>
                                                                                            <div className="event-post-meta ul-li-block mb-10">
                                                                                                <ul>
                                                                                                    <li>
                                                                                                        <span className="icon"><i className="fa fa-clock"></i></span> {item.Duration}
                                                                                                    </li>
                                                                                                    <li>
                                                                                                        <span className="icon"><i className="fa fa-map-marker"></i></span> {item.Address}
                                                                                                    </li>
                                                                                                    <li className="d-flex">
                                                                                                        <button
                                                                                                            className="gt-btn style6"
                                                                                                            style={{ padding: '15px' }}
                                                                                                            onClick={() => this.navigateEventEnquiry(item.EventID, 0)}
                                                                                                        >
                                                                                                            Enquiry <i className="fa fa-arrow-right-long" />
                                                                                                        </button>
                                                                                                        <button
                                                                                                            className="gt-btn style6"
                                                                                                            style={{ padding: '15px' }}
                                                                                                            onClick={() => this.navigateApplyEvent(item.URL)}
                                                                                                        >
                                                                                                            Apply Now <i className="fa fa-arrow-right-long" />
                                                                                                        </button>
                                                                                                    </li>
                                                                                                </ul>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                ))}
                                                                            </Slider>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </section>
                                                )}
                                            </React.Fragment>
                                        )) : (
                                            <div>
                                                <p className="text-center">No Contents Available</p>
                                            </div>
                                        )}
                                        {provided.placeholder}
                                    </div>
                                )}
                            </Droppable>
                        </DragDropContext>
                        {cmsSectionData.length > 0 && (
                            <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
                                <button className="btn btn-sm contentSubmit rounded-1 mt-4 btn-primary text-white" onClick={() => this.InsertUpdateCmsContent()}>
                                    Submit Contents
                                </button>
                            </div>
                        )}
                    </div>
                </section>

                {MenuID == 1 && (blogList.length > 0 &&
                    <section class="blog-section fix">
                        <div class="blog-wrapper style1 section-padding pt-0">
                            <div class="container">
                                <div class="row">
                                    <div class="col-12 d-flex justify-content-center">
                                        <div class="section-title title-area  mx-auto mb-50">
                                            <div class="subtitle d-flex justify-content-center"> <img src="assets/img/icon/arrowLeft_1.svg" alt="icon" /> <span> Blog & News
                                            </span><img src="assets/img/icon/arrowRight_1.svg" alt="icon" /></div>
                                            <h2 class="title text-center">Featured News And Insights</h2>
                                        </div>
                                    </div>
                                </div>
                                <div class="row gy-5 gx-30">
                                    {blogList.length > 0 && blogList.map((item) => (
                                        <div class="col-xl-4 col-md-6">
                                            <div class="blog-card style2 wow fadeInUp" data-wow-delay=".4s">
                                                <div class="blog-card-thumb" style={{ height: '480px' }}>
                                                    <p className="m-1">
                                                        {/* <span dangerouslySetInnerHTML={{ __html: this.sanitizeAndResizeImages(item.Details) }} /> */}
                                                        {/* {console.log("item.Details-->",item.Details)} */}
                                                        <span
                                                            dangerouslySetInnerHTML={{
                                                                __html: this.truncateSpecificTags(item.Details, 275),
                                                            }}
                                                        />
                                                    </p>
                                                </div>
                                                <div class="blog-card-body">
                                                    <h3><a style={{ color: '#744587' }}>{item.Title}</a></h3>
                                                    <div class="author-meta">
                                                        <div class="fancy-box style1">
                                                            <div class="item">
                                                                <h6>{item.Name}</h6>
                                                                <p>{item.Designation}</p>
                                                            </div>
                                                        </div>

                                                        <a class="link-btn style2"
                                                            onClick={() => this.navigateBlogDetails(item.BlogID)}
                                                        ><i
                                                            class="fa fa-arrow-right-long"></i></a>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                    {/*
                                <div class="col-xl-4 col-md-6">
                                    <div class="blog-card style2 wow fadeInUp" data-wow-delay=".8s">
                                        <div class="blog-card-thumb">
                                            <img src="assets/img/blog/blogThumb2_3.jpg" alt="thumb" />
                                        </div>
                                        <div class="blog-card-body">
                                            <div class="blog-meta">
                                                <div class="tag">Creative</div>
                                                <div class="date">MARCH 29, 2024</div>
                                            </div>
                                            <h3><a >How to secure your facebook</a></h3>
                                            <div class="author-meta">
                                                <div class="fancy-box style1">
                                                    <div class="item"><img src="assets/img/blog/blogProfile1_3.png" alt="thumb" />
                                                    </div>
                                                    <div class="item">
                                                        <h6>Admin</h6>
                                                        <p>Co, Founder</p>
                                                    </div>
                                                </div>

                                                <a class="link-btn style2"><i
                                                    class="fa fa-arrow-right-long"></i></a>
                                            </div>
                                        </div>
                                    </div>
                                </div> */}
                                </div>
                            </div>
                        </div>
                    </section >
                )}
                <>
                    <Modal show={isStaticUploadOpen} size="xl">
                        <Modal.Header>
                            <Modal.Title style={{ width: '100%', textAlign: 'center' }}>
                                {/* <div > */}
                                <h6> Upload Files - {MenuUrl ? MenuUrl : (MenuID == 1 && 'Home')}</h6>
                                {/* </div> */}
                            </Modal.Title>
                            <span
                                onClick={() => this.setState({ isStaticUploadOpen: false })}
                                style={{ cursor: "pointer", fontWeight: "800", marginRight: '15px' }}
                            >
                                X
                            </span>
                        </Modal.Header>
                        <Modal.Body style={{ height: 'calc(80vh - 76px)' }}>
                            <label htmlFor="upload-files" className="btn btn-primary mb-3">
                                Upload Files
                            </label>
                            <input
                                id="upload-files"
                                type="file"
                                multiple
                                accept=".jpg,.jpeg,.png,.gif,.webp,.pdf,.xls,.xlsx,.csv,application/pdf,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                style={{ display: 'none' }}
                                onChange={this.handleFileChange}
                            />

                            {this.state.cmsUploadData?.length > 0 && (
                                <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
                                    < table className="table table-bordered mt-3" >
                                        <thead>
                                            <tr>
                                                <th>File Name</th>
                                                <th>File URL</th>
                                                <th>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.cmsUploadData.map((file, index) => (
                                                file.isActive === 1 && (
                                                    <tr key={index}>
                                                        <td><a title='View' href={file.FileID && `${downloadUrl + file.FilePath}`} target="_blank">{file.FileName}</a></td>
                                                        <td
                                                            style={{ cursor: file.FileID ? "pointer" : "default", color: file.FileID ? "#007bff" : "inherit" }}
                                                            title={file.FileID ? "Click to copy URL" : ""}
                                                            onClick={() => {
                                                                if (file.FileID) {
                                                                    const fullUrl = `${downloadUrl + file.FilePath}`;
                                                                    navigator.clipboard.writeText(fullUrl).then(() => {
                                                                        toastSuccess("URL copied to clipboard!");
                                                                    }).catch(err => {
                                                                        toastError("Failed to copy URL: ", err);
                                                                    });
                                                                }
                                                            }}
                                                        >
                                                            {file.FileID ? `${downloadUrl + file.FilePath}` : file.FileName}
                                                        </td>

                                                        <td>
                                                            <button className="btn btn-sm btn-outline-danger ml-2" title="Remove File" onClick={() => this.removeFile(index, file.FileID)}>
                                                                <i class="fa fa-trash-o"></i>
                                                            </button>
                                                        </td>
                                                    </tr>
                                                )
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </Modal.Body>
                        <Modal.Footer>
                            <button className="btn btn-sm px-3 mb-1 mx-2" onClick={() => this.setState({ isStaticUploadOpen: false })}>Close</button>
                            <button className="btn btn-sm px-3 mb-1 mx-2" onClick={this.UploadStaticFiles}>Submit</button>
                        </Modal.Footer>
                    </Modal>
                </>
                <>
                    <Modal show={isStaticUploadOpenBanner} size="xl" style={{ left: '2%', top: "10%" }}>
                        <Modal.Header>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>

                                <Modal.Title>
                                    <h6 style={{ color: 'black', margin: 0 }}>Upload Banner</h6>
                                </Modal.Title>
                                {console.log(cmsBannerData, 'cmsBannerData')}
                                {/* Right Side: Buttons */}
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    {((cmsBannerData?.BannerFilepath || cmsBannerData?.FilePreview) || (cmsBannerData?.[0]?.BannerFilepath || cmsBannerData?.[0]?.FilePreview)) ? (
                                        <button
                                            className="btn btn-sm p-1 px-3 btn-outline-moddanger rounded-1 mb-1 mt-1"
                                            onClick={this.clearFileInput}
                                        >
                                            Remove
                                        </button>
                                    ) : (
                                        <>
                                            <label className="btn btn-sm p-1 px-3 btn-outline-modsuccess rounded-1 mb-1 mt-1">
                                                Upload
                                                <input
                                                    type="file"
                                                    accept=".jpg,.jpeg,.png"
                                                    onChange={this.handleBannerChange}
                                                    ref={(ref) => (this.fileInputRef = ref)}
                                                    style={{ display: 'none' }}
                                                />
                                            </label>
                                        </>
                                    )}


                                    {cmsBannerData?.isActive && (
                                        cmsBannerData?.isPublish ? (
                                            <button
                                                className="btn btn-sm p-1 px-2 rounded-1 btn-outline-modsec mb-1 mt-1"
                                                onClick={() => this.PublishCmsContent(cmsBannerData?.BannerID, 0)}
                                            >
                                                Unpublish
                                            </button>
                                        ) : (
                                            <button
                                                className="btn btn-sm p-1 px-3 rounded-1 btn-pub-btn mb-1 mt-1"
                                                onClick={() => this.PublishCmsContent(cmsBannerData?.BannerID, 1)}
                                            >
                                                Publish
                                            </button>
                                        )
                                    )}

                                    <span
                                        onClick={() => this.setState({ isStaticUploadOpenBanner: false })}
                                        style={{ cursor: "pointer", fontWeight: "800", marginLeft: '10px' }}
                                    >
                                        X
                                    </span>
                                </div>
                            </div>
                        </Modal.Header>

                        <Modal.Body style={{ height: 'calc(100vh - 375px)', textAlign: 'center' }}>
                            {/* Logic to show either the new local preview OR the existing saved path */}
                            {(cmsBannerData?.FilePreview || cmsBannerData?.BannerFilepath) ? (
                                <div style={{ position: "relative", display: "inline-block" }}>
                                    <img
                                        src={cmsBannerData?.FilePreview || (downloadUrl + cmsBannerData?.BannerFilepath)}
                                        alt="Banner Preview"
                                        style={{
                                            maxWidth: "100%",
                                            maxHeight: "300px",
                                            objectFit: "contain",
                                            border: "2px dashed #744587",
                                            padding: "5px"
                                        }}
                                    />
                                    <p className="mt-2 text-muted">{cmsBannerData.FileName || 'Selected Banner'}</p>
                                </div>
                            ) : (
                                <div className="p-5 border rounded" style={{ backgroundColor: '#f8f9fa' }}>
                                    <i className="fa fa-image fa-3x mb-3" style={{ color: '#ccc' }}></i>
                                    <p>No banner selected. Click "Upload" to select an image.</p>
                                    {bannerFileErr && <span className='text-danger'>{bannerFileErr}</span>}
                                </div>
                            )}
                        </Modal.Body>
                        <Modal.Footer>
                            <button className="btn btn-sm px-3 mb-1 mx-2 p-2 up-btn" onClick={() => this.setState({ isStaticUploadOpenBanner: false })}>Close</button>
                            <button className="btn btn-sm px-3 mb-1 mx-2  p-2 up-btn" onClick={this.UploadBannerFile}>Submit</button>
                        </Modal.Footer>
                    </Modal>
                    <Modal show={isStaticUploadOpen} size="xl">
                        <Modal.Header>
                            <Modal.Title style={{ width: '100%', textAlign: 'center' }}>
                                {/* <div > */}
                                <h6> Upload Files - {MenuUrl ? MenuUrl : (MenuID == 1 && 'Home')}</h6>
                                {/* </div> */}
                            </Modal.Title>
                            <span
                                onClick={() => this.setState({ isStaticUploadOpen: false })}
                                style={{ cursor: "pointer", fontWeight: "800", marginRight: '15px' }}
                            >
                                X
                            </span>
                        </Modal.Header>
                        <Modal.Body style={{ height: 'calc(80vh - 76px)' }}>
                            <label htmlFor="upload-files" className="btn btn-primary mb-3">
                                Upload Files
                            </label>
                            <input
                                id="upload-files"
                                type="file"
                                multiple
                                accept=".jpg,.jpeg,.png,.gif,.webp,.pdf,.xls,.xlsx,.csv,application/pdf,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                style={{ display: 'none' }}
                                onChange={this.handleFileChange}
                            />

                            {this.state.cmsUploadData?.length > 0 && (
                                <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
                                    < table className="table table-bordered mt-3" >
                                        <thead>
                                            <tr>
                                                <th>File Name</th>
                                                <th>File URL</th>
                                                <th>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.cmsUploadData.map((file, index) => (
                                                file.isActive === 1 && (
                                                    <tr key={index}>
                                                        <td><a title='View' href={file.FileID && `${downloadUrl + file.FilePath}`} target="_blank">{file.FileName}</a></td>
                                                        <td
                                                            style={{ cursor: file.FileID ? "pointer" : "default", color: file.FileID ? "#007bff" : "inherit" }}
                                                            title={file.FileID ? "Click to copy URL" : ""}
                                                            onClick={() => {
                                                                if (file.FileID) {
                                                                    const fullUrl = `${downloadUrl + file.FilePath}`;
                                                                    navigator.clipboard.writeText(fullUrl).then(() => {
                                                                        toastSuccess("URL copied to clipboard!");
                                                                    }).catch(err => {
                                                                        toastError("Failed to copy URL: ", err);
                                                                    });
                                                                }
                                                            }}
                                                        >
                                                            {file.FileID ? `${downloadUrl + file.FilePath}` : file.FileName}
                                                        </td>

                                                        <td>
                                                            <button className="btn btn-sm btn-outline-danger ml-2" title="Remove File" onClick={() => this.removeFile(index, file.FileID)}>
                                                                <i class="fa fa-trash-o"></i>
                                                            </button>
                                                        </td>
                                                    </tr>
                                                )
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </Modal.Body>
                        <Modal.Footer>
                            <button className="btn btn-sm px-3 mb-1 mx-2" onClick={() => this.setState({ isStaticUploadOpen: false })}>Close</button>
                            <button className="btn btn-sm px-3 mb-1 mx-2" onClick={this.UploadStaticFiles}>Submit</button>
                        </Modal.Footer>
                    </Modal>

                </>
                <div
                    className="focus-sec first-sec"
                    style={{
                        border: '1px solid #ccc',
                        padding: '10px',
                        borderRadius: '10px',
                        marginBottom: '15px',
                        backgroundColor: '#f9f9f9',
                        margin: '1rem'
                    }}
                >
                    <div
                        style={{
                            marginBottom: '5px',
                            cursor: 'grab',
                        }}
                    >
                        <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                        }}>
                            <strong style={{ color: 'black' }}>Footer Content</strong>
                            <div>
                                <a className="btn my-2  mx-1 p-1 px-2" onClick={() => this.insertUpdateFooter()}>Submit Footer</a>
                                {cmsFooterData?.isPublish ? <>
                                    <a className="btn my-2  mx-1 p-1 px-2" onClick={() => this.PublishCmsFooter(0)}>Unpublish Footer</a>
                                </> : <>
                                    <a className="btn my-2  mx-1 p-1 px-2" onClick={() => this.PublishCmsFooter(1)}>Publish Footer</a>
                                </>}
                            </div>
                        </div>
                        <div className="speaker-button text-lg-center m-2 text-center">

                            <JoditEditor value={cmsFooterData?.FooterContent} config={joditConfig}
                                onChange={(content) => this.handleEditorChangeFooter(content)} />
                        </div>
                    </div>
                </div>


                <Modal show={isOpen} size="lg" >
                    <Modal.Body className="pb-2 pt-2"
                        style={{
                            backgroundColor: '#744587',
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            backgroundRepeat: 'no-repeat',
                        }}
                    >
                        <span
                            className="pop-close"
                            onClick={() => this.setState({ isOpen: false }, () => {
                                const { intervalId } = this.state;
                                if (intervalId) {
                                    clearInterval(intervalId); // Stop the timer
                                    this.setState({ intervalId: null }); // Reset the interval ID
                                }
                            })}
                        >
                            X
                        </span>
                        <div className="container text-center p-4">
                            <img
                                src="assets/img/logo_1.png"
                                alt="logo"
                                className="image timer-pop"
                            />
                            <h2 className="py-3 text-center com-soon-tag">Coming Soon</h2>
                            {popDetails != {} && <h5 className="pb-5 timer-pop-text com-soon">
                                The {popMsg} will start on {popDetails["date"]}<sup>{popDetails["pronounce"]}</sup> {popDetails["month"]} {popDetails["year"]} at {popDetails["time"]} noon (IST)
                            </h5>
                            }
                            {/* <h5 className="pt-3 pb-4 timer-pop-text com-soon">
                                The registration will be on first come first basis.
                            </h5> */}
                            <div className="countdown-out mt-5">
                                <div class="countdown">
                                    <div>
                                        <span id="days">{timeLeft.days}</span>
                                        <small>Days</small>
                                    </div>
                                    <div>
                                        <span id="hours">{timeLeft.hours}</span>
                                        <small>Hours</small>
                                    </div>
                                    <div>
                                        <span id="minutes">{timeLeft.minutes}</span>
                                        <small>Minutes</small>
                                    </div>
                                    <div>
                                        <span id="seconds">{timeLeft.seconds}</span>
                                        <small>Seconds</small>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
            </>
        )

    }
}
// ReactDOM.render(<Homepage />, document.querySelector('.demo-carousel'))

export default withRouter(connect(null, {
    countDownDate_action, getWebsiteBlogList_action, getCmsContent_action,
    insertUpdateCmsContent_action, insertUpdateCmsFooter_action, publishCmsContent_action,
    publishCmsFooter_action, insertUpdateCmsContentSection_action, updateCmsContentStatus_action,
    insertUpdateCMSStaticUploads_action, deleteCmsStaticFiles_action, get_eventMaster_list_action,
    insertUpdateCmsBanner_action, publishCmsBanner_action
})(Homepage));